import AgreementPdfDropzone from './AgreementPdfDropzone.component';

export default AgreementPdfDropzone;
